// components

import AddIcon from '../components/AddIcon';
import AddImageIcon from '../components/AddImageIcon';
import ApprovalIcon from '../components/affiliate/ApprovalIcon';
import ArrowBackIcon from '../components/affiliate/ArrowBackIcon';
import ArrowForwardIcon from '../components/affiliate/ArrowForwardIcon';
import CrownIcon from '../components/affiliate/CrownIcon';
import DashIcon from '../components/affiliate/DashIcon';
import DateIcon from '../components/affiliate/DateIcon';
import FeeIcon from '../components/affiliate/FeeIcon';
import HelpIcon from '../components/affiliate/HelpIcon';
import LoginIcon from '../components/affiliate/LoginIcon';
import LogoutIcon from '../components/affiliate/LogoutIcon';
import NotificationIcon from '../components/affiliate/NotificationIcon';
import RankingIcon from '../components/affiliate/RankingIcon';
import ResetIcon from '../components/affiliate/ResetIcon';
import WithDrawalIcon from '../components/affiliate/WithDrawalIcon';
import AlarmIcon from '../components/AlarmIcon';
import AlbumIcon from '../components/AlbumIcon';
import ArrowIcon from '../components/ArrowIcon';
import AsteriskIcon from '../components/AsteriskIcon';
import AutoPlaySetIcon from '../components/AutoPlaySetIcon';
import BackgroundIcon from '../components/BackgroundIcon';
import BadgeIcon from '../components/BadgeIcon';
import BagIcon from '../components/BagIcon';
import BgMusicIcon from '../components/BgMusicIcon';
import BlankIcon from '../components/BlankIcon';
import BookIcon from '../components/BookIcon';
import BookmarkIcon from '../components/BookmarkIcon';
import BubbleChatRoundLogoIcon from '../components/BubbleChatRoundLogoIcon';
import BubbleIcon from '../components/BubbleIcon';
import BubblePickIcon from '../components/BubblePickIcon';
import BubbleSetIcon from '../components/BubbleSetIcon';
import CameraIcon from '../components/CameraIcon';
import ChangeIcon from '../components/ChangeIcon';
import CharacterBlockIcon from '../components/CharacterBlockIcon';
import CharacterLIcon from '../components/CharacterLIcon';
import CharacterRIcon from '../components/CharacterRIcon';
import ChargeStationIcon from '../components/ChargeStationIcon';
import ChatStarIcon from '../components/ChatStarIcon';
import CheckIcon from '../components/CheckIcon';
import CheckLargeIcon from '../components/CheckLargeIcon';
import ClearRoomIcon from '../components/ClearRoomIcon';
import CloseIcon from '../components/CloseIcon';
import CoinIcon from '../components/CoinIcon';
import CommentIcon from '../components/CommentIcon';
import CommunityEmojiIcon from '../components/CommunityEmojiIcon';
import CommunityIcon from '../components/CommunityIcon';
import ContestIcon from '../components/ContestIcon';
import ControlIcon from '../components/ControlIcon';
import CountryIcon from '../components/CountryIcon';
import CreateIcon from '../components/CreateIcon';
import CurrentLocationIcon from '../components/CurrentLocationIcon';
import DefaultImageIcon from '../components/DefaultImageIcon';
import DefaultUserIcon from '../components/DefaultUserIcon';
import DeleteIcon from '../components/DeleteIcon';
import DiceIcon from '../components/DiceIcon';
import DiscoverIcon from '../components/DiscoverIcon';
import DocumentIcon from '../components/DocumentIcon';
import DotIcon from '../components/DotIcon';
import DownloadIcon from '../components/DownloadIcon';
import DownloadTextIcon from '../components/DownloadTextIcon';
import DragIcon from '../components/DragIcon';
import EditIcon from '../components/EditIcon';
import EditProfileCameraIcon from '../components/EditProfileCameraIcon';
import EmailIcon from '../components/EmailIcon';
import EmotionIcon from '../components/EmotionIcon';
import EqualizerIcon from '../components/EqualizerIcon';
import EventLogoIcon from '../components/EventLogoIcon';
import EyeIcon from '../components/EyeIcon';
import FavoriteIcon from '../components/FavoriteIcon';
import FileIcon from '../components/FileIcon';
import FilterIcon from '../components/FilterIcon';
import FireIcon from '../components/FireIcon';
import FlipIcon from '../components/FlipIcon';
import FollowerIcon from '../components/FollowerIcon';
import FooterCircleIcon from '../components/FooterCircleIcon';
import GifIcon from '../components/GifIcon';
import GiftIcon from '../components/GiftIcon';
import GoTopIcon from '../components/GoTopIcon';
import HashIcon from '../components/HashIcon';
import HistoryChatBubbleIcon from '../components/HistoryChatBubbleIcon';
import HomeIcon from '../components/HomeIcon';
import ImageIcon from '../components/ImageIcon';
import InfoIcon from '../components/InfoIcon';
import LanguageIcon from '../components/LanguageIcon';
import LinkIcon from '../components/LinkIcon';
import LoadingIcon from '../components/LoadingIcon';
import LockIcon from '../components/LockIcon';
import LogoIcon from '../components/LogoIcon';
import MailIcon from '../components/MailIcon';
import MemoryIcon from '../components/MemoryIcon';
import MenuIcon from '../components/MenuIcon';
import MinusIcon from '../components/MinusIcon';
import ModifyIcon from '../components/ModifyIcon';
import MoreIcon from '../components/MoreIcon';
import MoveLargeIcon from '../components/MoveLargeIcon';
import MoveSmallIcon from '../components/MoveSmallIcon';
import MovieIcon from '../components/MovieIcon';
import MultiImageIcon from '../components/MultiImageIcon';
import MultiImageUploadIcon from '../components/MultiImageUploadIcon';
import MyPageIcon from '../components/MyPageIcon';
import NarrationIcon from '../components/NarrationIcon';
import NarrativeIcon from '../components/NarrativeIcon';
import NewPageIcon from '../components/NewPageIcon';
import OpenIcon from '../components/OpenIcon';
import PasswordIcon from '../components/PasswordIcon';
import PaymentMethodIcon from '../components/PaymentMethodIcon';
import PinIcon from '../components/PinIcon';
import PlaySetIcon from '../components/PlaySetIcon';
import PlusIcon from '../components/PlusIcon';
import ProfilePageStatisticsIcon from '../components/ProfilePageStatisticsIcon';
import PromotionBadgeIcon from '../components/PromotionBadgeIcon';
import PushNotificationIcon from '../components/PushNotificationIcon';
import QuestionIcon from '../components/QuestionIcon';
import RadioIcon from '../components/RadioIcon';
import ReactionIcon from '../components/ReactionIcon';
import RemoveIcon from '../components/RemoveIcon';
import ReplyLineIcon from '../components/ReplyLineIcon';
import RewardIcon from '../components/RewardIcon';
import RocketIcon from '../components/RocketIcon';
import RotateIcon from '../components/RotateIcon';
import SceneIcon from '../components/SceneIcon';
import ScrollUpIcon from '../components/ScrollUpIcon';
import SearchIcon from '../components/SearchIcon';
import SelectSmallIcon from '../components/SelectSmallIcon';
import SendEmailIcon from '../components/SendEmailIcon';
import SendIcon from '../components/SendIcon';
import SettingIcon from '../components/SettingIcon';
import ShampooIcon from '../components/ShampooIcon';
import ShareSocialIcon from '../components/ShareIcon';
import SignIcon from '../components/SignIcon';
import SocialIcon from '../components/SocialIcon';
import SortIcon from '../components/SortIcon';
import SoundIcon from '../components/SoundIcon';
import SparkleIcon from '../components/SparkleIcon';
import SquareIcon from '../components/SquareIcon';
import StarIcon from '../components/StarIcon';
import StatisticsIcon from '../components/StatisticsIcon';
import StatusIcon from '../components/StatusIcon';
import StoreIcon from '../components/StoreIcon';
import StudioBackgroundIcon from '../components/StudioBackgroundIcon';
import StudioToolIcon from '../components/StudioToolIcon';
import SupportIcon from '../components/SupportIcon';
import TabIcon from '../components/TabIcon';
import TailIcon from '../components/TailIcon';
import TextIcon from '../components/TextIcon';
import ThemeIcon from '../components/ThemeIcon';
import ThrillIcon from '../components/ThrillIcon';
import ChargeIcon from '../components/tingle/ChargeIcon';
import IncentiveIcon from '../components/tingle/IncentiveIcon';
import { default as TingleLogoIcon } from '../components/tingle/LogoIcon';
import PotionIcon from '../components/tingle/PotionIcon';
import RoundLogoIcon from '../components/tingle/RoundLogoIcon';
import SproutIcon from '../components/tingle/SproutIcon';
import TopIcon from '../components/TopIcon';
import TransferIcon from '../components/TransferIcon';
import UniverseIcon from '../components/UniverseIcon';
import UpLoadPhotoIcon from '../components/UpLoadPhotoIcon';
import UserIcon from '../components/UserIcon';
import VoteIcon from '../components/VoteIcon';
import WarningIcon from '../components/WarningIcon';
import WritingIcon from '../components/WritingIcon';

// 버블 아이콘
export const CommonIcon = {
  Logo: LogoIcon,
  Bubble: BubbleIcon,
};

export const StudioIcon = {
  ClearRoom: ClearRoomIcon,
  Background: BackgroundIcon,
  Narrative: NarrativeIcon,
  Status: StatusIcon,
  BgMusic: BgMusicIcon,
  AutoPlay: AutoPlaySetIcon,
  Image: ImageIcon,
  Top: TopIcon,
  CurrentLocation: CurrentLocationIcon,
  StudioBackground: StudioBackgroundIcon,
  NewPage: NewPageIcon,
};

export const BubbleChatIcon = {
  Universe: UniverseIcon,
  Scene: SceneIcon,
  Dice: DiceIcon,
  Theme: ThemeIcon,
  Square: SquareIcon,
  MultiImage: MultiImageIcon,
  Store: StoreIcon,
  BubbleChatRoundLogo: BubbleChatRoundLogoIcon,
  Shampoo: ShampooIcon,
};

export const AffiliateIcon = {
  Approval: ApprovalIcon,
  Dash: DashIcon,
  Date: DateIcon,
  Fee: FeeIcon,
  Login: LoginIcon,
  Logout: LogoutIcon,
  Notification: NotificationIcon,
  Reset: ResetIcon,
  Crown: CrownIcon,
  WithDrawal: WithDrawalIcon,
  Ranking: RankingIcon,
  ArrowForward: ArrowForwardIcon,
  ArrowBack: ArrowBackIcon,
  HelpIcon: HelpIcon,
};

export const TingleIcon = {
  Logo: TingleLogoIcon,
  Store: StoreIcon,
  Incentive: IncentiveIcon,
  Sprout: SproutIcon,
  Potion: PotionIcon,
  Charge: ChargeIcon,
  RoundLogo: RoundLogoIcon,
};

// Icon Components
export const Icon = {
  BubblePick: BubblePickIcon,
  Search: SearchIcon,
  Check: CheckIcon,
  Menu: MenuIcon,
  Sort: SortIcon,
  Arrow: ArrowIcon,
  More: MoreIcon,
  Text: TextIcon,
  Plus: PlusIcon,
  Minus: MinusIcon,
  Edit: EditIcon,
  Comment: CommentIcon,
  Change: ChangeIcon,
  Close: CloseIcon,
  Delete: DeleteIcon,
  Home: HomeIcon,
  Discover: DiscoverIcon,
  Language: LanguageIcon,
  MyPage: MyPageIcon,
  Remove: RemoveIcon,
  Rotate: RotateIcon,
  Sign: SignIcon,
  Tab: TabIcon,
  Writing: WritingIcon,
  PlaySet: PlaySetIcon,
  BubbleSet: BubbleSetIcon,
  Create: CreateIcon,
  Drag: DragIcon,
  Equalizer: EqualizerIcon,
  File: FileIcon,
  Info: InfoIcon,
  Open: OpenIcon,
  Setting: SettingIcon,
  Social: SocialIcon,
  Star: StarIcon,
  Mail: MailIcon,
  Modify: ModifyIcon,
  Radio: RadioIcon,
  Favorite: FavoriteIcon,
  PushNotification: PushNotificationIcon,
  Alarm: AlarmIcon,
  Community: CommunityIcon,
  Camera: CameraIcon,
  Album: AlbumIcon,
  ReplyLine: ReplyLineIcon,
  Hash: HashIcon,
  Bookmark: BookmarkIcon,
  MoveSmall: MoveSmallIcon,
  Eye: EyeIcon,
  CharacterR: CharacterRIcon,
  CharacterL: CharacterLIcon,
  Password: PasswordIcon,
  Sound: SoundIcon,
  Download: DownloadIcon,
  DownloadText: DownloadTextIcon,
  Loading: LoadingIcon,
  Warning: WarningIcon,
  UpLoadPhoto: UpLoadPhotoIcon,
  Narration: NarrationIcon,
  Follower: FollowerIcon,
  Contest: ContestIcon,
  Coin: CoinIcon,
  Add: AddIcon,
  Send: SendIcon,
  MoveLarge: MoveLargeIcon,
  GoTop: GoTopIcon,
  Badge: BadgeIcon,
  Email: EmailIcon,
  SendEmail: SendEmailIcon,
  CheckLarge: CheckLargeIcon,
  EditProfileCamera: EditProfileCameraIcon,
  SelectSmall: SelectSmallIcon,
  FooterCircle: FooterCircleIcon,
  ProfilePageStatistics: ProfilePageStatisticsIcon,
  ShareSocial: ShareSocialIcon,
  User: UserIcon,
  StudioTool: StudioToolIcon,
  Rocket: RocketIcon,
  Gift: GiftIcon,
  Book: BookIcon,
  Question: QuestionIcon,
  Fire: FireIcon,
  Dot: DotIcon,
  Reaction: ReactionIcon,
  CommunityEmoji: CommunityEmojiIcon,
  Vote: VoteIcon,
  Movie: MovieIcon,
  Link: LinkIcon,
  Gif: GifIcon,
  Pin: PinIcon,
  Control: ControlIcon,
  HistoryChatBubble: HistoryChatBubbleIcon,
  DefaultUser: DefaultUserIcon,
  Thrill: ThrillIcon,
  Lock: LockIcon,
  Tail: TailIcon,
  PromotionBadge: PromotionBadgeIcon,
  Document: DocumentIcon,
  Reward: RewardIcon,
  ChatStar: ChatStarIcon,
  ChargeStation: ChargeStationIcon,
  ScrollUp: ScrollUpIcon,
  EventLogo: EventLogoIcon,
  Asterisk: AsteriskIcon,
  MultiImageUpload: MultiImageUploadIcon,
  DefaultImage: DefaultImageIcon,
  Flip: FlipIcon,
  Memory: MemoryIcon,
  Support: SupportIcon,
  Country: CountryIcon,
  Statistics: StatisticsIcon,
  PaymentMethod: PaymentMethodIcon,
  CharacterBlock: CharacterBlockIcon,
  Transfer: TransferIcon,
  Emotion: EmotionIcon,
  Bag: BagIcon,
  Sparkle: SparkleIcon,
  Blank: BlankIcon,
  Filter: FilterIcon,
  AddImage: AddImageIcon,
  ...StudioIcon,
  ...CommonIcon,
  ...BubbleChatIcon,
  ...AffiliateIcon,
  ...TingleIcon,
};
